import ProductTile from "../ProductTile";
import getProductImageComponent from "./getProductImageComponent";

const mapProductsToProductTiles = ({
  products,
  pageNumber,
  focusTileIndex,
  isInitialPage,
  dealBannerEnabled,
  dealBannerShownAsDiscount
}) => {
  const items = products.map(({ product }, index) => (
    <ProductTile
      {...product}
      key={product.tileId}
      pageNumber={pageNumber}
      focusOnMount={index === focusTileIndex}
      ProductImageComponent={getProductImageComponent({ isInitialPage, index })}
      index={index}
      dealBannerEnabled={dealBannerEnabled}
      dealBannerShownAsDiscount={dealBannerShownAsDiscount}
    />
  ));

  return items;
};

export default mapProductsToProductTiles;
